import React, {useState} from 'react';
import {useControllerProps} from '../../Widget/ControllerContext';
import {classes} from './BottomMobileSummary.st.css';
import {CheckoutSlot} from '../../CheckoutSlot';
import {SlotId} from '../../../../domain/utils/slotId';
import {BottomFoldableSummarySection} from './BottomFoldableSummarySection/BottomFoldableSummarySection';
import {BiMobilePosition} from '../../../../domain/utils/bi.util';
import {CartSummary} from '../CartSummary';
import {useExperiments} from '@wix/yoshi-flow-editor';
import {SPECS} from '../../../../common/constants';

export enum BottomMobileSummaryDataHooks {
  paymentAndPlaceOrderStep = 'BottomMobileSummaryDataHooks.paymentAndPlaceOrderStep',
  placeOrderFastFlow = 'BottomMobileSummaryDataHooks.placeOrderFastFlow',
}
export interface BottomMobileSummaryProps {
  dataHook: string;
  checkboxesRef?: React.RefObject<HTMLDivElement>;
  paymentWidgetRef?: React.RefObject<HTMLDivElement>;
}

export const BottomMobileSummary = ({dataHook}: BottomMobileSummaryProps) => {
  const {
    checkoutStore: {isFastFlow},
  } = useControllerProps();
  const shouldShowSlots = !isFastFlow;
  const {experiments} = useExperiments();
  const checkoutUIRevampOrderSummary = experiments.enabled(SPECS.CheckoutUIRevampOrderSummary);
  const [isOpen, setIsIsOpen] = useState(false);

  return (
    <div data-hook={dataHook} className={classes.root}>
      <div className={classes.container}>
        {shouldShowSlots && (
          /* istanbul ignore next: test slot */ <CheckoutSlot
            className={checkoutUIRevampOrderSummary ? classes.slotBefore : classes.slotBeforeOld}
            slotId={SlotId.BeforeSummaryCheckoutSlot}
          />
        )}
      </div>
      {<BottomFoldableSummarySection onClick={({isOpen}) => setIsIsOpen(isOpen)} isOpen={isOpen} />}
      <CartSummary
        className={classes.bottomSummary}
        showTitle={false}
        showLineItems={isOpen}
        showSlots={shouldShowSlots}
        mobilePosition={BiMobilePosition.bottom}
      />
      <div className={classes.container}>
        {
          /* istanbul ignore next: test slot */ shouldShowSlots ? (
            <CheckoutSlot
              className={checkoutUIRevampOrderSummary ? classes.slotAfter : classes.slotAfterOld}
              slotId={SlotId.AfterSummaryCheckoutSlot}
            />
          ) : null
        }
      </div>
    </div>
  );
};
